// @flow
import _ from 'lodash/fp';

import type { IDependencyResolver } from "../annotation/di";


/*
	// conserved //
	You should understand that your changes here can break other pages of rgs
	// conserved //
*/

export type Services = string[];
export type Views = string[];

export type Dependencies = Services | {
	services?: Services,
	view?: Views,
}

export type TempChainItem = {
	done: *[],
	next: Dependencies
};

const finishChain = (result: TempChainItem) => result.done;

const addServices = (resolver: Function) => (result: TempChainItem) => ({
	next: result.next,
	done: result.done.concat(
		(result.next.services || []).map(resolver)
	),
});


const addView = (resolver: Function) => (result: TempChainItem) => ({
	next: result.next,
	done: result.done.concat(
		(result.next.view || []).map(resolver)
	),
});

const addOuterArgs = (classArgs: *[]) => (dependencies: Dependencies) => ({
	next: dependencies,
	done: classArgs || [],
});

const injectDependencies = (
	dependencyResolver: IDependencyResolver,
	dependencies: Dependencies,
	classArgs: *[]
) => {
	if (Array.isArray(dependencies)) {
		return dependencies.map(dependencyResolver.getServiceByName);
	}


	return _.compose(
		_.filter(Boolean),

		finishChain,
		addServices(dependencyResolver.getServiceByName),
		addView(dependencyResolver.getViewModelByName),
		addOuterArgs(classArgs)
	)(dependencies);
};


//so approach through inherit lets us to composite many decorators
//and make our code better!
const withDependencies = (dependencies: Dependencies) => (ParentConstructor: Class<*>) => {

	return class extends ParentConstructor {
		constructor (dependencyResolver: IDependencyResolver, ...classArgs: *[]) {
			super(...injectDependencies(dependencyResolver, dependencies, classArgs));
		}
	};
};


export {
	withDependencies,
};
